import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[nonZeroRequired]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: NonZeroRequiredDirective,
      multi: true
    }
  ]
})
export class NonZeroRequiredDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === undefined || value === '' || parseFloat(value) === 0) {
      return { nonZeroRequired: true };
    }
    return null;
  }
}
